import React from 'react';
import { FaDiscord } from 'react-icons/fa';
import { SiKofi } from 'react-icons/si';
import './SocialSupport.css';

const SocialSupport = () => {
  return (
    <div className="social-container">
      <a
        href="https://discord.gg/Qa5Qe4eJeH"
        target="_blank"
        rel="noopener noreferrer"
        className="social-btn social-btn--discord"
      >
        <FaDiscord /> Join Discord
      </a>
      <a
        href="https://ko-fi.com/pokecomp"
        target="_blank"
        rel="noopener noreferrer"
        className="social-btn social-btn--kofi"
      >
        <SiKofi /> Support Us
      </a>
    </div>
  );
};

export default SocialSupport;
